import React, { useState } from "react";
import Avatar from "../../Avatar/Avatar";
import moment from "moment";
import employeeAccountStatusFormat from "../../../utils/FormatEmployeeAccountStatus/employeeAccountStatusFormat";

import { EMPLOYEE_ACCOUNT_STATUS } from "../../../../src/redux/constants/actvityType";

const DirectoryCardData = ({ requestdata }) => {
  const statusInfo = employeeAccountStatusFormat(requestdata?.account_status);

  return (
    <div className="relative border border-gray-300 bg-white rounded-xl shadow-sm hover:shadow-lg transition-transform hover:-translate-y-1 duration-200 flex flex-col">
      {/* Status Badge */}
      <div
        className="absolute top-3 right-3 px-3 py-1 rounded-full text-xs font-semibold"
        style={{
          backgroundColor: statusInfo.bgColor,
          color: statusInfo.fontColor,
          border:
            statusInfo.borderColor !== "none"
              ? `1px solid ${statusInfo.borderColor}`
              : "none",
        }}
      >
        {statusInfo.label}
      </div>

      {/* Avatar Section */}
      <div className="bg-blue-100 flex flex-col items-center justify-center rounded-t-xl p-3">
   <div className="w-36 h-36 rounded-full overflow-hidden">
 <Avatar
  image={requestdata?.photo}
  firstName={requestdata?.first_name}
  lastName={requestdata?.last_name}
  width="36"
  height="36"
  initialsClassName="text-5xl font-bold"
/>
</div>


        <p className="text-lg font-semibold text-blue-800 mt-3">
          {requestdata?.first_name || ""} {requestdata?.last_name || ""}
        </p>
        <span>{requestdata?.designation_title || "-"}</span>
      </div>

      {/* Details */}
      <div className="p-4 text-sm text-gray-800 space-y-2 border-t border-gray-200">
        <div className="flex justify-between">
          <span className="font-medium">Employee Serial</span>
          <span>{requestdata?.employee_serial || "-"}</span>
        </div>
        <div className="flex justify-between">
          <span className="font-medium">Department</span>
          <span>{requestdata?.department_name || "-"}</span>
        </div>
        <div className="flex justify-between">
          <span className="font-medium">Email</span>
          <span className="whitespace-nowrap">{requestdata?.email || "-"}</span>
        </div>
        <div className="flex justify-between">
          <span className="font-medium">Location</span>
          <span>{requestdata?.office_location || "-"}</span>
        </div>
        <div className="flex justify-between">
          <span className="font-medium">Phone No</span>
          <span>{requestdata?.phone || "-"}</span>
        </div>

        <div className="flex justify-between">
          <span className="font-medium">
            {statusInfo.status === EMPLOYEE_ACCOUNT_STATUS.ACTIVE
              ? "Joining Date"
              : statusInfo.status === EMPLOYEE_ACCOUNT_STATUS.ONBOARDING
              ? "Joining Date"
              : "Last Date"}
          </span>

          <span>
            {statusInfo.status === EMPLOYEE_ACCOUNT_STATUS.ACTIVE
              ? requestdata?.joining_date
                ? moment(requestdata.joining_date).isValid()
                  ? moment(requestdata.joining_date).format("DD-MM-YYYY")
                  : "-"
                : "-"
              : statusInfo.status === EMPLOYEE_ACCOUNT_STATUS.ONBOARDING
              ? "-"
              : requestdata?.ending_date
              ? moment(requestdata.ending_date).isValid()
                ? moment(requestdata.ending_date).format("DD-MM-YYYY")
                : "-"
              : "-"}
          </span>
        </div>

        <div className="flex justify-between">
          <span className="font-medium">Line Manager:</span>
          <span>{requestdata?.line_manager_name || "-"}</span>
        </div>
      </div>
    </div>
  );
};

export default DirectoryCardData;
